'use strict';

import { Entity } from '../Entity';

export class UserSignature extends Entity {
  protected signatureId;
  protected signature;

  protected user;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.signatureId = data.signatureId;
    this.signature = data.signature;
  }

  public getSignatureId() {
    return this.signatureId;
  }

  public getSignature() {
    return this.signature;
  }
}
